export enum UnsubscribedMarketingType {
  UNSUBSCRIBED_MARKETING_TYPE_UNKNOWN = 'UNSUBSCRIBED_MARKETING_TYPE_UNKNOWN',
  FAIRE_SENT = 'FAIRE_SENT',
  BRAND_CRM_SENT = 'BRAND_CRM_SENT',
}
